<template>
    <div class="message">
        <div class="head">
            <h6>{{message.subject}}</h6>
            <div>{{message.created_at | moment('dddd, MMMM Do YYYY, h:mm:ss a')}}</div>
            <div><strong>To: </strong>{{message.to}}</div>
        </div>

        <div v-html="message.raw_html"/>
    </div>
</template>

<script>
    import {mapActions} from "vuex";

    export default {
        name: "Message",
        props: ['code', 'id'],
        data: function() {
            return {
                message: {}
            }
        },
        methods: {
            ...mapActions(['getMessage']),
            loadMessage: function() {
                this.getMessage({secret: this.code, id: this.id}).then(message => {
                    this.message = message;
                }, err => {
                    this.$router.push({name: 'home'});
                    console.error(err);
                });
            }
        },
        watch: {
            'id': function() {
                this.message = {};
                this.loadMessage();
            }
        },
        mounted: function() {
            this.loadMessage();
        }
    };
</script>

<style lang="scss" scoped>
    .message {
        padding: 0.25rem;
        background-color: #f7f7f7;
        border-radius: 0.25rem;

        .head {
            padding: 1rem;
            font-size: 0.9rem;
        }
    }
</style>
